export {default} from './AirbnbCodeVerificationProcedure';



// WEBPACK FOOTER //
// ./src/containers/AirbnbCodeVerificationProcedure/index.ts